import { render, staticRenderFns } from "./newsdetails.vue?vue&type=template&id=72a20c29&scoped=true&"
import script from "./newsdetails.vue?vue&type=script&lang=js&"
export * from "./newsdetails.vue?vue&type=script&lang=js&"
import style0 from "./newsdetails.vue?vue&type=style&index=0&id=72a20c29&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a20c29",
  null
  
)

export default component.exports